import { withAuthenticationRequired } from "@auth0/auth0-react";

const ProtectComponent = ({ component }) => {
  const ProtectedCompononent = withAuthenticationRequired(component);
  return <ProtectedCompononent />;
};

export default ProtectComponent;
